export const TEXTS = {
  DOWNLOAD_APP: 'Download our App',
  SUBSCRIBE_NEWSLETTER: 'Subscribe to Newsletter',
  ENTER_EMAIL: 'Enter your email',
  SUBMIT: 'Submit',
  FOR_QUERIES: 'FOR ANY HELP, YOU MAY CALL US AT',
  CONTACT: '1800-266-3333',
  AVAILABILITY: '(Monday to Saturday: 10 am - 10 pm, Sunday: 10 am - 7 pm)',
  WHO_WE_ARE: 'Who are we',
  HELP: 'Help',
  HELP_CENTER: 'Help Center',
  QUICKLINKS: 'Quicklinks',
  FOLLOW_US: 'Follow Us',
  ABOUT_US: 'About Us',
  CAREERS: 'Careers',
  PRESS: 'Press',
  TERMS: 'Terms & Conditions',
  SHIPPING: 'Shipping & Return Policy',
  IN_POLICY: 'Privacy Policy',
  RESPONSIBLE_DISCLOSURE: 'Responsible Disclosure',
  OFFERS: 'Offers',
  SITEMAP: 'Sitemap',
  EMAIL_REQUIRED: 'Please Enter email id',
  EMAIL_INVALID: 'Please Enter valid email id',
  OOPS: 'Something went wrong!!!',
  GOOGLE_LINK_NAME: 'Google Play Store',
  APPLE_LINK_NAME: 'Apple App Store',
  STYLE_FILES: 'Style Files',
};
export const APP_PROMO = '/app-promo';
export const GOOGLE_PLAYSTORE_LINK = 'https://play.google.com/store/apps/details?id=com.fsn.nds';
export const GOOGLE_PLAYSTORE_IMG =
  'https://www.nykaafashion.com/pub/media/wysiwyg/homepagemiddle/googlePlay.png';

export const APL_APPSTORE_LINK =
  'https://itunes.apple.com/in/app/nykaa-design-studio/id1439872423?mt=8';
export const APL_APPSTORE_IMG =
  'https://www.nykaafashion.com/pub/media/wysiwyg/homepagemiddle/appleStore.png';

export const INSTA_LINK = 'https://www.instagram.com/nykaafashion/';
export const FB_LINK = 'https://www.facebook.com/NykaaFashion';

export const FOOTER_LINKS = {
  ABOUT_US: '/lp/about-us?root=footer',
  CAREERS: '/lp/careers',
  PRESS: 'https://www.nykaa.com/who_are_we/#press?root=footer',
  TERMS: '/lp/terms-and-conditions',
  SHIPPING: '/lp/shipping-and-return-policy',
  IN_POLICY: '/lp/privacy-policy',
  OFFERS: '/offer.html?root=nav_1&ptype=sale_page',
  SITEMAP: '/cp/sitemap',
  HELP_CENTER: '/gateway-api/omsApis/helpCenter?domain=NYKAA_FASHION',
  RESPONSIBLE_DISCLOSURE: '/lp/responsible-disclosure',
  STYLE_FILES: '/style-files/',
};

export const ICON_DIMENSION = 24;
export const ICON_SIZES = {
  DWEB: '20px',
  MWEB: '20px',
};

export const TITLES = {
  POPULAR_LINKS: 'Popular Links',
  EXPLORE_NYKAA_FASHION: 'Explore Nykaa Fashion',
};
